export default __webpack_public_path__ + "media/images/filtre-right-2d908c2e4ecea005f2f77c6125d24e5c.png";